window.Findation = window.Findation || {};

// Product PDP: similar-product swap, gallery crossfade, widget resync.
(function () {
  const STORAGE_KEY = "boa:similar-variant-selection";
  const SECTION_SELECTOR = ".shopify-section.shopify-section--product";
  const GALLERY_SELECTOR = ".product-single__gallery";
  const DETAILS_SELECTOR = ".product-single__details";
  const MIRRARLY_WRAPPER = ".mirrarlyInlineWrapper, .js-mirrarlyInlineWrapper";
  const MIRRARLY_INLINE = "[id^='js-mirrarlyInline-']";
  const FINDATION_WRAPPER = ".findation-button-wrapper";
  const QUIZ_WRAPPER = ".product__quiz-shade-wrapper";
  // Must exceed .product-gallery-fade / .boa-product-details-enter (0.5s).
  const FADE_MS = 600;
  const FINDATION_RETRY_MS = 100;
  const FINDATION_RETRY_MAX = 40;
  const FINDATION_KEY =
    "29c4a6b8af448c50c2f57914dd7e5d9e743bb6e7c503c82e93287026d8d5";

  const inflight = new Map();
  const sectionIdByHandle = new Map();
  let originalHandle = null;
  let restoreChecked = false;
  let replacing = false;
  let colorPickSeq = 0;
  let swapped = false;
  let variantListenersTeardown = null;

  const sectionsApi = () => window.Shopify && window.Shopify.theme.sections;

  function boaParse(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (e) {
      return fallback;
    }
  }

  function boaRoot() {
    return (
      document.getElementById("section-product") ||
      document.querySelector(SECTION_SELECTOR) ||
      document
    );
  }

  function boaQuizDest(root = boaRoot()) {
    return root.querySelector(QUIZ_WRAPPER);
  }

  function boaSelectedVariantId(root = boaRoot()) {
    const input = root.querySelector('[name="id"][data-product-select]');
    return input ? String(input.value).split(",")[0] : "";
  }

  function buildProductUrl(handle, variantId, options = {}) {
    const root = (window.theme && theme.routes && theme.routes.root) || "/";
    const url = new URL(`${root}products/${handle}`, window.location.origin);
    if (variantId) {
      url.searchParams.set("variant", String(variantId).split(",")[0]);
    }
    if (options.sectionId) {
      url.searchParams.set("section_id", options.sectionId);
    }
    return options.absolute ? url.toString() : `${url.pathname}${url.search}`;
  }

  function productAbsoluteUrl(product) {
    return buildProductUrl(
      product && product.handle,
      boaSelectedVariantId(),
      { absolute: true }
    );
  }

  function boaBareProductPathname(handle) {
    return new URL(buildProductUrl(handle, null, { absolute: true })).pathname;
  }

  function boaMainProductContainer() {
    const root = document.getElementById("section-product");
    if (!root) return null;
    if (root.getAttribute("data-section-type") === "featured-product") {
      return null;
    }
    return root;
  }

  function boaPageSectionId() {
    const container = boaMainProductContainer();
    return container ? container.getAttribute("data-section-id") : null;
  }

  function boaEnableHistoryState() {
    const container = boaMainProductContainer();
    return Boolean(container);
  }

  function resetPageSimilarState() {
    originalHandle = null;
    restoreChecked = false;
  }

  function boaPathForHandle(handle) {
    if (!handle) return window.location.pathname;
    const next = window.location.pathname.replace(
      /(\/products\/)[^/]+/,
      `$1${handle}`
    );
    return next.includes(`/products/${handle}`)
      ? next
      : boaBareProductPathname(handle);
  }

  function boaUpdateProductHistory(handle, variantId, updateUrl = true) {
    if (!handle) return;
    const original = originalHandle || handle;
    const variant = variantId ? String(variantId).split(",")[0] : "";
    const onSimilar = handle !== original;
    const similarState =
      onSimilar && variant
        ? { anchor: original, handle, variant }
        : null;

    try {
      if (similarState) {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(similarState));
      } else {
        sessionStorage.removeItem(STORAGE_KEY);
      }
    } catch (e) {
      /* storage unavailable */
    }

    // Path change only on section swap. Theme updateHistoryState owns ?variant=
    // (and selling_plan) for subsequent shade picks once pathname is correct.
    if (!updateUrl) return;

    const next = new URL(window.location.href);
    next.pathname = boaPathForHandle(handle);
    if (variant) {
      next.searchParams.set("variant", variant);
    } else {
      next.searchParams.delete("variant");
    }
    next.searchParams.delete("section_id");
    const urlString = `${next.pathname}${next.search}${next.hash}`;
    window.history.replaceState({ path: urlString }, "", urlString);
  }

  function boaRawSimilarState() {
    try {
      const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
      if (stored && stored.handle) return stored;
    } catch (e) {
      /* storage unavailable */
    }
    return null;
  }

  function boaReadSavedSimilar() {
    const similar = boaRawSimilarState();
    return similar && similar.variant ? similar : null;
  }

  function boaMarkSwapped() {
    if (swapped) return;
    swapped = true;
    document.addEventListener("click", boaOnMirrarlyClick, true);
  }

  function boaOrderVariants(section) {
    const current = section.querySelector("[data-current-group]");
    const similar = section.querySelector("[data-similar-group]");
    if (!current || !similar) return;

    if (!originalHandle) {
      originalHandle = current.dataset.variantGroupHandle;
    }
    const anchor = originalHandle;
    const currentIsAnchor =
      current.dataset.variantGroupHandle === anchor;
    const similarIsAnchor =
      similar.dataset.variantGroupHandle === anchor;
    let original;
    if (currentIsAnchor) {
      original = current;
    } else if (similarIsAnchor) {
      original = similar;
    } else {
      original = null;
    }
    if (original) {
      const other = original === current ? similar : current;
      original.parentElement.insertBefore(original, other);
    }
    current
      .closest("[data-swatches-container]")
      ?.classList.add("boa-variants-ready");
  }

  let gallerySlideHolds = 0;

  function boaFlickity() {
    return (
      (window.themeVendor && window.themeVendor.Flickity) ||
      window.Flickity ||
      null
    );
  }

  function boaGallerySliders() {
    return document.querySelectorAll(
      "[data-product-single-media-slider], [data-product-single-media-thumbs]"
    );
  }

  function boaHoldGallerySlide() {
    const Flickity = boaFlickity();
    if (!Flickity || !Flickity.data) return;
    gallerySlideHolds += 1;
    boaGallerySliders().forEach((slider) => {
      const flkty = Flickity.data(slider);
      if (!flkty || typeof flkty.select !== "function" || flkty.__boaSelect) {
        return;
      }
      flkty.__boaSelect = flkty.select.bind(flkty);
      flkty.select = function () {};
    });
  }

  function boaReleaseGallerySlide() {
    gallerySlideHolds = Math.max(0, gallerySlideHolds - 1);
    if (gallerySlideHolds > 0) return;
    const Flickity = boaFlickity();
    if (!Flickity || !Flickity.data) return;
    boaGallerySliders().forEach((slider) => {
      const flkty = Flickity.data(slider);
      if (!flkty || !flkty.__boaSelect) return;
      flkty.select = flkty.__boaSelect;
      delete flkty.__boaSelect;
    });
  }

  function boaCrossfadeGallery(currentGallery, incomingGallery, onReady) {
    currentGallery.classList.remove(
      "product-gallery-wrapper",
      "product-gallery-wrapper-is-active",
      "product-gallery-fade"
    );
    currentGallery.style.width = "";
    currentGallery.style.opacity = "";
    currentGallery.style.transition = "";
    void currentGallery.offsetWidth;

    const newGallery = incomingGallery.cloneNode(true);
    const galleryWidth = currentGallery.getBoundingClientRect().width;
    newGallery.classList.add("product-gallery-wrapper");
    newGallery.style.width = galleryWidth + "px";
    newGallery.style.visibility = "hidden";
    currentGallery.insertAdjacentElement("beforebegin", newGallery);
    void newGallery.offsetWidth;

    let started = false;
    const startFade = () => {
      if (started) return;
      started = true;
      newGallery.style.visibility = "";
      void newGallery.offsetWidth;
      currentGallery.classList.add("product-gallery-fade");

      let finished = false;
      const finishOnce = () => {
        if (finished) return;
        finished = true;
        currentGallery.remove();
        newGallery.classList.add("product-gallery-wrapper-is-active");
        boaReleaseGallerySlide();
      };

      currentGallery.addEventListener("transitionend", (event) => {
        if (
          event.target !== currentGallery ||
          event.propertyName !== "opacity"
        ) {
          return;
        }
        finishOnce();
      });
      setTimeout(finishOnce, FADE_MS);
    };

    // Strip Zoom / media-switch hooks before section re-init so the outgoing
    // gallery stays visible for the fade but is not collected by new Zoom().
    currentGallery
      .querySelectorAll(
        "[data-zoom-wrapper], [data-product-single-media-wrapper], [data-thumbnail-id]"
      )
      .forEach((el) => {
        el.removeAttribute("data-zoom-wrapper");
        el.removeAttribute("data-product-single-media-wrapper");
        el.removeAttribute("data-thumbnail-id");
      });

    if (typeof onReady === "function") onReady(newGallery, startFade);
    else startFade();
    return newGallery;
  }

  function boaSwapProductDetails(liveProduct, freshProduct, liveGalleries) {
    const incomingDetails = freshProduct.querySelector(DETAILS_SELECTOR);
    const liveDetails = liveProduct.querySelector(DETAILS_SELECTOR);
    let details = liveDetails;
    if (liveDetails && incomingDetails) {
      details = incomingDetails.cloneNode(true);
      details.classList.add("boa-product-details-enter");
      boaPlaceLiveMirrarly(liveDetails, details);
      boaPlaceLiveFindation(liveDetails, details);
      liveDetails.replaceWith(details);
      requestAnimationFrame(() => {
        if (details.isConnected) {
          details.classList.add("boa-product-details-enter-active");
        }
      });
    }

    const keep = new Set((liveGalleries || []).filter(Boolean));
    if (details) keep.add(details);
    [...liveProduct.children].forEach((child) => {
      if (!keep.has(child)) child.remove();
    });
    [...freshProduct.children].forEach((child) => {
      if (child.matches(`${GALLERY_SELECTOR}, ${DETAILS_SELECTOR}`)) return;
      liveProduct.appendChild(child.cloneNode(true));
    });
    return details;
  }

  function boaRememberProductSectionId(handle, html) {
    if (!handle || !html) return null;
    const doc = new DOMParser().parseFromString(html, "text/html");
    const productRoot = doc.querySelector("#section-product");
    const sectionId =
      productRoot && productRoot.getAttribute("data-section-id");
    if (sectionId) sectionIdByHandle.set(handle, sectionId);
    return sectionId;
  }

  function boaResolvedProductSectionId(handle, pageSectionId) {
    const cached = sectionIdByHandle.get(handle);
    if (cached) return cached;
    if (handle && handle === originalHandle && pageSectionId) {
      sectionIdByHandle.set(handle, pageSectionId);
      return pageSectionId;
    }
    return null;
  }

  function boaFetchProductSection(handle, variantId, pageSectionId) {
    const sectionId = boaResolvedProductSectionId(handle, pageSectionId);
    const url = sectionId
      ? buildProductUrl(handle, variantId, { sectionId })
      : buildProductUrl(handle, variantId);
    if (inflight.has(url)) return inflight.get(url);
    const request = fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(response.statusText);
        return response.text();
      })
      .then((html) => {
        if (!sectionId) boaRememberProductSectionId(handle, html);
        return html;
      })
      .finally(() => {
        inflight.delete(url);
      });
    inflight.set(url, request);
    return request;
  }

  function boaSetSimilarLoading(sectionElement, loading) {
    if (!sectionElement) return;
    sectionElement.classList.toggle("boa-similar-loading", loading);
    if (loading) {
      sectionElement.setAttribute("aria-busy", "true");
    } else {
      sectionElement.removeAttribute("aria-busy");
    }
  }

  function boaReloadProductSections(sectionElement) {
    const api = sectionsApi();
    if (!api || !api.load || !api.unload) return;
    const innerSections = sectionElement.querySelectorAll(
      "[data-section-type]"
    );
    api.unload(innerSections);
    api.load("*", innerSections);
  }

  function boaFormatMirrarlyPrice(cents) {
    if (typeof cents !== "number") return undefined;
    const format =
      (window.theme && theme.moneyFormat) || "${{amount}}";
    const currency = window.themeVendor && themeVendor.themeCurrency;
    if (currency && typeof currency.formatMoney === "function") {
      return currency.formatMoney(cents, format);
    }
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, format);
    }
    return "$" + (cents / 100).toFixed(2);
  }

  function boaUpdateSchemaFromSection(sourceRoot) {
    if (!sourceRoot) return;
    const schemaScript = sourceRoot.querySelector(
      'script[type="application/ld+json"]'
    );
    const liveSection = document.querySelector(SECTION_SELECTOR);
    const liveSchema =
      liveSection &&
      liveSection.querySelector('script[type="application/ld+json"]');
    if (schemaScript && liveSchema) {
      liveSchema.textContent = schemaScript.textContent;
    }
  }

  function boaUpdateDisplayedProductMeta(product) {
    if (!product) return;
    const pageUrl = buildProductUrl(product.handle, boaSelectedVariantId(), {
      absolute: true,
    });
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.href = buildProductUrl(product.handle, null, { absolute: true });
    }

    const image = boaMediaSrc(
      product.featured_image || (product.images && product.images[0])
    );
    const setOg = (prop, value) => {
      if (value == null || value === "") return;
      let live = document.querySelector(`meta[property="${prop}"]`);
      if (!live) {
        live = document.createElement("meta");
        live.setAttribute("property", prop);
        document.head.appendChild(live);
      }
      live.setAttribute("content", value);
    };
    setOg("og:title", product.title || "");
    setOg("og:url", pageUrl);
    if (image) setOg("og:image", image.startsWith("http") ? image : "https:" + image);
    if (product.description) {
      const text = String(product.description)
        .replace(/<[^>]+>/g, " ")
        .replace(/\s+/g, " ")
        .trim();
      if (text) setOg("og:description", text.slice(0, 300));
    }
  }

  function boaUpdateHeadAfterSwap(sourceRoot) {
    boaUpdateSchemaFromSection(sourceRoot);
    boaUpdateDisplayedProductMeta(boaProduct());
  }

  async function swapProductSection(handle, variantId) {
    const fallbackUrl = buildProductUrl(handle, variantId);
    const sectionElement = document.querySelector(SECTION_SELECTOR);
    if (!sectionElement) {
      window.location.href = fallbackUrl;
      return;
    }

    replacing = true;
    boaSetSimilarLoading(sectionElement, true);
    try {
      const html = await boaFetchProductSection(
        handle,
        variantId,
        boaPageSectionId()
      );
      const nextSection = new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(SECTION_SELECTOR);
      if (!nextSection) throw new Error("Product section not found");
      boaMarkSwapped();
      boaOrderVariants(nextSection);

      const liveProduct = sectionElement.querySelector("[data-product]");
      const freshProduct = nextSection.querySelector("[data-product]");
      const currentGallery =
        liveProduct && liveProduct.querySelector(GALLERY_SELECTOR);
      const incomingGallery =
        freshProduct && freshProduct.querySelector(GALLERY_SELECTOR);
      const desktop =
        window.theme &&
        window.innerWidth >= theme.sizes.small;
      const canCrossfade =
        liveProduct &&
        freshProduct &&
        currentGallery &&
        incomingGallery &&
        desktop;

      if (!canCrossfade) {
        boaReleaseGallerySlide();
        const api = sectionsApi();
        if (api && api.unload) {
          api.unload(sectionElement.querySelectorAll("[data-section-type]"));
        }
        boaPlaceLiveMirrarly(sectionElement, nextSection);
        boaPlaceLiveFindation(sectionElement, nextSection);
        sectionElement.replaceWith(nextSection);
        boaUpdateProductHistory(handle, variantId, boaEnableHistoryState());
        boaUpdateHeadAfterSwap(nextSection);
        replacing = false;
        boaSetSimilarLoading(sectionElement, false);
        if (api && api.load) api.load("*");
        document.dispatchEvent(new CustomEvent("boa:product:section:replaced"));
        bindVariantSections();
        return;
      }

      boaCrossfadeGallery(
        currentGallery,
        incomingGallery,
        (newGallery, startFade) => {
          const nextDetails = boaSwapProductDetails(liveProduct, freshProduct, [
            currentGallery,
            newGallery,
          ]);
          [...freshProduct.attributes].forEach(({ name, value }) => {
            liveProduct.setAttribute(name, value);
          });
          boaOrderVariants(liveProduct);
          boaUpdateProductHistory(handle, variantId, boaEnableHistoryState());
          boaUpdateHeadAfterSwap(nextSection);
          try {
            boaReloadProductSections(sectionElement);
          } finally {
            startFade();
          }
          setTimeout(() => {
            if (nextDetails && nextDetails.isConnected) {
              nextDetails.classList.remove(
                "boa-product-details-enter",
                "boa-product-details-enter-active"
              );
            }
            replacing = false;
            boaSetSimilarLoading(sectionElement, false);
            document.dispatchEvent(
              new CustomEvent("boa:product:section:replaced")
            );
            bindVariantSections();
          }, FADE_MS);
        }
      );
    } catch (e) {
      boaReleaseGallerySlide();
      replacing = false;
      boaSetSimilarLoading(sectionElement, false);
      window.location.href = fallbackUrl;
    }
  }

  // Keep original swatch group first after reload on a similar-product URL.
  function restoreAnchorForVariantOrder() {
    const saved = boaReadSavedSimilar();
    if (!saved || !saved.anchor || !saved.handle || saved.handle === saved.anchor) {
      return;
    }
    const current = document.querySelector("[data-current-group]");
    const currentHandle = current && current.dataset.variantGroupHandle;
    if (currentHandle === saved.handle) {
      originalHandle = saved.anchor;
    }
  }

  function clearVariantSectionListeners() {
    if (variantListenersTeardown) {
      variantListenersTeardown();
      variantListenersTeardown = null;
    }
  }

  function bindVariantSections() {
    const container = boaMainProductContainer();
    if (!container) return;

    const fieldset = container.querySelector("[data-swatches-container]");

    // Clear stale similar-swap key on a fresh navigate so back_forward restore
    // only runs when landing on a similar-product URL.
    if (!restoreChecked) {
      restoreChecked = true;
      const navEntry = performance.getEntriesByType("navigation")[0];
      const shouldClear =
        !fieldset || (navEntry && navEntry.type === "navigate");
      if (shouldClear) {
        try {
          sessionStorage.removeItem(STORAGE_KEY);
        } catch (e) {
          /* storage unavailable */
        }
      } else {
        restoreAnchorForVariantOrder();
      }
    }

    if (!fieldset) return;

    clearVariantSectionListeners();
    boaOrderVariants(container);

    const sectionId = container.getAttribute("data-section-id");
    if (sectionId) {
      const currentGroup = container.querySelector("[data-current-group]");
      let handle =
        currentGroup && currentGroup.dataset.variantGroupHandle;
      if (!handle) {
        try {
          const json = container.querySelector("[data-product-json]");
          handle = json ? JSON.parse(json.textContent).handle : "";
        } catch (e) {
          handle = "";
        }
      }
      if (handle) sectionIdByHandle.set(handle, sectionId);
    }

    if (
      fieldset.querySelector("[data-similar-group]") &&
      !document.getElementById("boa-similar-variants-detached")
    ) {
      const detached = document.createElement("form");
      detached.id = "boa-similar-variants-detached";
      detached.hidden = true;
      detached.setAttribute("aria-hidden", "true");
      detached.addEventListener("submit", (event) => event.preventDefault());
      document.body.appendChild(detached);
    }

    const onSimilarChange = (event) => {
      if (replacing) return;
      const input = event.target.closest("[data-similar-option]");
      if (!input) return;
      // Separate radio names → both groups can stay checked; keep only this one.
      fieldset.querySelectorAll("input.swatch__input:checked").forEach((el) => {
        if (el !== input) el.checked = false;
      });
      const handle = input.dataset.similarHandle;
      const variantId = input.dataset.variantId;
      if (!handle || !variantId) return;
      const similarGroup = input.closest("[data-similar-group]");
      if (similarGroup && similarGroup.hasAttribute("data-same-template")) {
        const pageId = boaPageSectionId();
        if (pageId) sectionIdByHandle.set(handle, pageId);
      }
      boaHoldGallerySlide();
      swapProductSection(handle, variantId);
    };
    fieldset.addEventListener("change", onSimilarChange);

    const onVariantChange = (event) => {
      if (replacing) return;
      // Keep shade name in sync without a section fetch (mobile path).
      // Theme updateHistoryState owns ?variant= / selling_plan.
      const checked = fieldset.querySelector(
        "input.swatch__input:checked:not([data-similar-option])"
      );
      if (checked) {
        const labels = fieldset.querySelectorAll(
          "[data-swatches-label] .radio__legend__label"
        );
        if (labels.length >= 2) {
          labels[labels.length - 1].textContent = "   " + checked.value;
        }
      }
    };
    // theme:variant:change is dispatched on the outer product-template section.
    const variantHost =
      container.closest("[data-section-type='product-template']") || container;
    variantHost.addEventListener("theme:variant:change", onVariantChange);

    variantListenersTeardown = () => {
      fieldset.removeEventListener("change", onSimilarChange);
      variantHost.removeEventListener("theme:variant:change", onVariantChange);
    };
  }

  function boaPlaceLiveMirrarly(liveRoot, nextRoot) {
    if (!liveRoot || !nextRoot || liveRoot === nextRoot) return;
    const live = liveRoot.querySelector(MIRRARLY_WRAPPER);
    const nextQuiz = nextRoot.querySelector(QUIZ_WRAPPER);
    const nextMirrarly = nextRoot.querySelector(MIRRARLY_WRAPPER);
    if (!nextQuiz) return;

    // Destination product has no Try It On block — drop the carried widget.
    if (!nextMirrarly) {
      if (live) live.remove();
      return;
    }
    if (!live) return;

    // Keep Mirrarly's server allowlist (products with makeup config).
    const liveInline = live.querySelector(MIRRARLY_INLINE);
    const nextInline = nextMirrarly.querySelector(MIRRARLY_INLINE);
    if (liveInline && nextInline && nextInline.dataset.linkedProductIds) {
      liveInline.dataset.linkedProductIds = nextInline.dataset.linkedProductIds;
    }

    nextRoot.querySelectorAll(MIRRARLY_WRAPPER).forEach((node) => {
      if (node !== live) node.remove();
    });
    if (live.parentNode !== nextQuiz) nextQuiz.appendChild(live);
  }

  function boaPlaceLiveFindation(liveRoot, nextRoot) {
    if (!liveRoot || !nextRoot || liveRoot === nextRoot) return;
    const live = liveRoot.querySelector(FINDATION_WRAPPER);
    const nextQuiz = nextRoot.querySelector(QUIZ_WRAPPER);
    const nextFindation = nextRoot.querySelector(FINDATION_WRAPPER);
    if (!nextQuiz) return;

    if (!nextFindation) {
      if (live) live.remove();
      return;
    }
    if (!live || !live.querySelector("#findation-button-iframe")) return;

    nextRoot.querySelectorAll(FINDATION_WRAPPER).forEach((node) => {
      if (node !== live) node.remove();
    });
    if (live.parentNode !== nextQuiz) {
      const quizButton = nextQuiz.querySelector("#quiz-button");
      if (quizButton) nextQuiz.insertBefore(live, quizButton);
      else nextQuiz.prepend(live);
    }
  }

  function boaMoveMirrarlyToQuiz() {
    const destination = boaQuizDest();
    const widget = document.querySelector(MIRRARLY_WRAPPER);
    if (!destination || !widget) return false;
    if (widget.parentNode !== destination) {
      destination.appendChild(widget);
    }
    return true;
  }

  function boaProduct() {
    const json = boaRoot().querySelector("[data-product-json]");
    return json ? boaParse(json.textContent, null) : null;
  }

  function boaMediaSrc(image, stripProtocol) {
    if (!image) return "";
    const src = typeof image === "string" ? image : image.src || "";
    return stripProtocol ? String(src).replace(/^https?:/, "") : src;
  }

  function boaKeepLast(nodes, isMatch, preferred) {
    const list = [...nodes];
    if (!list.length) return null;
    const matching = isMatch ? list.filter(isMatch) : list;
    const keeper =
      preferred || matching[matching.length - 1] || list[list.length - 1];
    list.forEach((node) => node !== keeper && node.remove());
    return keeper;
  }

  // --- Findation ---

  let boaFindationRetryTimer = null;

  function boaMarkFindationReady(iframe) {
    const wrap =
      (iframe && iframe.closest && iframe.closest(FINDATION_WRAPPER)) ||
      (iframe && iframe.parentElement) ||
      boaRoot().querySelector(FINDATION_WRAPPER);
    if (wrap) wrap.classList.add("is-ready");
  }

  function boaSizeFindationButton(iframe) {
    if (!iframe) return;
    const mobile = window.matchMedia("(max-width: 767px)").matches;
    iframe.style.width = mobile ? "140px" : "160px";
    iframe.style.height = "40px";
  }

  function boaSyncFindationProduct(product) {
    if (!product || product.id == null) return false;
    const productId = String(product.id);
    const productUrl = productAbsoluteUrl(product);

    if (window.Findation) {
      Findation.productId = productId;
      if ("productUrl" in Findation) Findation.productUrl = productUrl;
    }

    const overlay =
      (window.Findation && Findation.iframe) ||
      document.getElementById("findation-iframe");
    if (!overlay || !overlay.src || overlay.style.display === "block") {
      return false;
    }
    try {
      const url = new URL(overlay.src, window.location.origin);
      url.searchParams.set("productId", productId);
      url.searchParams.set("productUrl", productUrl);
      url.searchParams.set("href", productUrl);
      url.searchParams.set("target_product_id", "");
      if (overlay.src !== url.href) overlay.src = url.href;
      return true;
    } catch (e) {
      return false;
    }
  }

  function boaScheduleFindationRetry() {
    if (boaFindationRetryTimer) return;
    let tries = 0;
    boaFindationRetryTimer = setInterval(function () {
      if (initFindation() || ++tries > FINDATION_RETRY_MAX) {
        clearInterval(boaFindationRetryTimer);
        boaFindationRetryTimer = null;
      }
    }, FINDATION_RETRY_MS);
  }

  function initFindation() {
    const root = boaRoot();
    const wrapper = root.querySelector(FINDATION_WRAPPER);
    if (!wrapper) return true;

    // Findation script is loaded before this file (defer order in boaideas-assets).
    if (typeof Findation.init !== "function") {
      boaScheduleFindationRetry();
      return false;
    }

    const product = boaProduct();
    if (!product || product.id == null) {
      boaScheduleFindationRetry();
      return false;
    }

    const productId = String(product.id);
    const el =
      wrapper.querySelector("#findation-widget-button") ||
      root.querySelector("#findation-widget-button") ||
      document.getElementById("findation-widget-button");
    const buttonIframe =
      wrapper.querySelector("#findation-button-iframe") ||
      document.getElementById("findation-button-iframe");

    if (buttonIframe) {
      const host = buttonIframe.closest(FINDATION_WRAPPER);
      if (host && host !== wrapper) {
        host.classList.toggle(
          "is-ready",
          wrapper.classList.contains("is-ready") ||
            (buttonIframe.offsetWidth > 1 && buttonIframe.offsetHeight > 1)
        );
        wrapper.replaceWith(host);
      }
      boaSyncFindationProduct(product);
      boaSizeFindationButton(buttonIframe);
      if (buttonIframe.offsetWidth > 1 && buttonIframe.offsetHeight > 1) {
        boaMarkFindationReady(buttonIframe);
      }
      return true;
    }

    if (replacing || !el) {
      boaScheduleFindationRetry();
      return false;
    }

    Findation.widgetEmbedded = function (iframe) {
      boaSizeFindationButton(iframe);
      boaMarkFindationReady(iframe);
    };

    wrapper.classList.remove("is-ready");
    const next = document.createElement("div");
    next.id = "findation-widget-button";
    el.replaceWith(next);
    const mobile = window.matchMedia("(max-width: 767px)").matches;
    Findation.init(next, FINDATION_KEY, {
      productId,
      productUrl: productAbsoluteUrl(product),
      buttonWidth: mobile ? "140px" : "160px",
      buttonHeight: "40px",
    });
    const iframe =
      next.parentElement &&
      next.parentElement.querySelector("#findation-button-iframe");
    boaSizeFindationButton(iframe);
    return true;
  }

  // --- Yotpo ---

  function boaIsYotpoProductReviewWidget(el) {
    if (!el) return false;
    const type = (el.getAttribute("widget-type") || "").toLowerCase();
    if (type && /subscription|loyalty|reward|referral/.test(type)) {
      return false;
    }
    const id = (el.id || "").toLowerCase();
    if (/loyalty|reward|referral|subscription/.test(id)) return false;
    if (
      el.closest(
        "[class*='yotpo_loyalty'], [class*='loyalty_rewards'], [class*='yotpo-loyalty']"
      )
    ) {
      return false;
    }
    return (
      el.hasAttribute("data-yotpo-product-id") ||
      el.classList.contains("yotpo-reviews-star-ratings-widget") ||
      el.classList.contains("yotpo-reviews-main-widget") ||
      el.id === "yotpo-reviews-main-widget"
    );
  }

  function boaYotpoWidgetIsPainted(el) {
    if (!el) return false;
    return Boolean(
      el.querySelector(
        ".yotpo-sr-bottom-line-summary, .yotpo-reviews-main-widget, .yotpo-review"
      )
    );
  }

  function boaRemountYotpoWidget(el, product) {
    const next = el.cloneNode(false);
    next.innerHTML = "";
    // Drop Yotpo runtime markers so initWidgets treats the node as fresh.
    ["data-yotpo-initialized", "data-yotpo-element-loaded", "data-yotpo-widget-uuid", "data-yotpo-preloaded-data"].forEach(
      (attr) => next.removeAttribute(attr)
    );
    next.setAttribute("data-yotpo-product-id", String(product.id));
    if (next.hasAttribute("data-yotpo-cart-product-id")) {
      next.setAttribute("data-yotpo-cart-product-id", String(product.id));
    }
    next.setAttribute("data-yotpo-name", product.title || "");
    next.setAttribute("data-yotpo-url", productAbsoluteUrl(product));
    const image = boaMediaSrc(
      product.featured_image || (product.images && product.images[0])
    );
    if (image) {
      next.setAttribute("data-yotpo-image-url", image);
    } else {
      next.removeAttribute("data-yotpo-image-url");
    }
    el.replaceWith(next);
    return next;
  }

  function boaInitYotpoWidgets() {
    const api =
      (window.yotpoWidgetsContainer &&
        window.yotpoWidgetsContainer.initWidgets &&
        window.yotpoWidgetsContainer) ||
      (window.yotpo && window.yotpo.initWidgets && window.yotpo);
    if (api) api.initWidgets();
  }

  function boaSyncSealSubscriptions() {
    const product = boaProduct();
    if (!product) return;
    const root = boaRoot();
    const payload = JSON.stringify(product);
    root
      .querySelectorAll(".sealsubs-target-element, [data-seal-extension]")
      .forEach((el) => {
        el.setAttribute("data-handle", product.handle);
        el.setAttribute("data-product-id", String(product.id));
        el.setAttribute("data-product", payload);
      });
    const seal = window.SealSubs;
    if (seal && typeof seal.refresh === "function") {
      seal.refresh();
    }
  }

  function boaSyncYotpo(rebind) {
    const product = boaProduct();
    if (!product || !rebind) return;

    const productId = String(product.id);
    let needsInit = false;
    document
      .querySelectorAll(".yotpo-widget-instance, [data-yotpo-product-id]")
      .forEach((el) => {
        if (!boaIsYotpoProductReviewWidget(el)) return;
        // Skip detached/orphan nodes Yotpo sometimes leaves on <body>.
        if (!el.isConnected || el.parentElement === document.body) return;
        const sameProduct =
          String(el.getAttribute("data-yotpo-product-id") || "") === productId;
        if (sameProduct && boaYotpoWidgetIsPainted(el)) return;
        if (!sameProduct || el.getAttribute("data-yotpo-element-loaded") === "true") {
          boaRemountYotpoWidget(el, product);
        }
        needsInit = true;
      });
    if (needsInit) boaInitYotpoWidgets();
  }

  // --- Mirrarly ---

  function boaLinkedIds(inline) {
    const linked = boaParse(inline.dataset.linkedProductIds, []);
    return (Array.isArray(linked) ? linked : []).map(String);
  }

  const mirrarlyMakeups = new Map();

  function boaOnMirrarlyClick(event) {
    const target = event.target;
    const element =
      target && target.closest ? target : target && target.parentElement;
    const button = element && element.closest(".mirrarlyInlineBtn");
    if (!button || typeof startIframeFlow !== "function") return;
    if (window.Shopify && window.Shopify.designMode) return;
    const inline = button.closest(MIRRARLY_INLINE);
    // Consume before early returns so Mirrarly's listener cannot open a second session.
    event.preventDefault();
    event.stopPropagation();
    if (!inline || document.getElementById("js-mirrarlyIframe")) return;
    const product = boaProduct();
    if (product) boaSyncMirrarlyData(product, false);
    const productData = boaParse(inline.dataset.productData, null);
    if (!productData || productData.id == null) return;
    const productId = String(productData.id);
    // startIframeFlow skips showLoading; mirror tryOnProduct so the button stays disabled.
    if (typeof showLoading === "function") showLoading(button.id);
    startIframeFlow({
      isCombo: false,
      loadingTarget: button.id,
      productData,
      onNoMakeup: () => {
        if (typeof showUnsupportedAlert === "function") {
          showUnsupportedAlert(
            inline,
            inline.dataset.appAlertNoMakeupInline,
            button.id
          );
        }
      },
      loadMakeups: async () => {
        if (!mirrarlyMakeups.has(productId)) {
          const common = document.getElementById("js-mirrarlyCommon");
          const proxy = (common && common.dataset.proxyPath) || "/apps/mirrarly";
          const response = await fetch(
            `${proxy}/proxy/get-makeups?productId=${productId}`
          );
          if (!response.ok) throw new Error("Mirrarly makeup request failed");
          const data = await response.json();
          mirrarlyMakeups.set(
            productId,
            Array.isArray(data.makeups) ? data.makeups : []
          );
        }
        const variantIds = (productData.variants || []).map((variant) =>
          String(variant.id)
        );
        return mirrarlyMakeups
          .get(productId)
          .filter((makeup) =>
            variantIds.includes(String(makeup.productVariantId))
          )
          .sort(
            (a, b) =>
              variantIds.indexOf(String(a.productVariantId)) -
              variantIds.indexOf(String(b.productVariantId))
          );
      },
    });
  }

  function boaSyncMirrarlyData(product) {
    const selectedId = boaSelectedVariantId();
    document.querySelectorAll(MIRRARLY_INLINE).forEach((inline) => {
      const fallback = boaParse(inline.dataset.productData, {});
      const priorVariants = Array.isArray(fallback.variants)
        ? fallback.variants
        : [];
      const variants = (product.variants || []).map((variant) => {
        const prior = priorVariants.find(
          (item) => String(item.id) === String(variant.id)
        );
        const price =
          prior && prior.price !== undefined
            ? prior.price
            : boaFormatMirrarlyPrice(variant.price);
        return {
          id: variant.id,
          title: variant.public_title || variant.title,
          image: boaMediaSrc(
            variant.featured_image || variant.image || (prior && prior.image),
            true
          ),
          price,
          available: variant.available !== false,
        };
      });
      if (selectedId) {
        const index = variants.findIndex((v) => String(v.id) === selectedId);
        if (index > 0) variants.unshift(variants.splice(index, 1)[0]);
      }
      inline.dataset.productData = JSON.stringify({
        id: product.id,
        title: product.title,
        image:
          boaMediaSrc(
            product.featured_image || (product.images && product.images[0]),
            true
          ) ||
          fallback.image ||
          "",
        variants,
      });
      // Do not mutate linkedProductIds — Mirrarly uses that allowlist to
      // decide which products may show Try It On.
    });
  }

  function boaMirrarlySupportsProduct(productId, inline) {
    if (productId == null || !inline) return false;
    return boaLinkedIds(inline).includes(String(productId));
  }

  function remountMirrarly(rebind) {
    const product = boaProduct();
    const currentId = product ? product.id : undefined;
    const dest = boaQuizDest();

    boaKeepLast(
      boaRoot().querySelectorAll("#quiz-button"),
      (button) =>
        !currentId ||
        String(button.getAttribute("data-product-id") || "") ===
          String(currentId)
    );
    boaMoveMirrarlyToQuiz();
    boaKeepLast(
      document.querySelectorAll(MIRRARLY_WRAPPER),
      (wrapper) => {
        const inline = wrapper.querySelector(MIRRARLY_INLINE);
        if (!inline) return false;
        const data = boaParse(inline.dataset.productData, {});
        return currentId && String(data.id) === String(currentId);
      },
      dest && dest.querySelector(MIRRARLY_WRAPPER)
    );

    // First load: leave Mirrarly's server-rendered data alone. After a similar
    // swap the carried widget must be rewritten for product B.
    if (!swapped || !product) return;

    boaSyncMirrarlyData(product);
    document.querySelectorAll(MIRRARLY_WRAPPER).forEach((wrapper) => {
      const inline = wrapper.querySelector(MIRRARLY_INLINE);
      wrapper.hidden = !boaMirrarlySupportsProduct(product.id, inline);
    });
  }

  let boaPvcCountedProductId = "";

  function boaPvcProductIdFromScript(text) {
    const match = /var\s+productId\s*=\s*['"](\d+)['"]/.exec(text);
    return match ? match[1] : "";
  }

  function boaSyncPvcVisitors() {
    const root = boaRoot();
    root.querySelectorAll(".pvc-widget").forEach((widget) => {
      const host =
        widget.closest(".shopify-app-block") || widget.parentElement;
      if (!host || !root.contains(host)) return;
      host.querySelectorAll("script").forEach((oldScript) => {
        const text = oldScript.textContent;
        if (!text || !/visitorscounter\.app|pvc-widget/i.test(text)) return;
        const productId = boaPvcProductIdFromScript(text);
        if (productId && productId === boaPvcCountedProductId) {
          window["__pvcIncremented_" + productId] = Date.now();
        }
        // Section swaps insert script nodes without executing them.
        const s = document.createElement("script");
        s.textContent = text;
        oldScript.replaceWith(s);
        if (productId) boaPvcCountedProductId = productId;
      });
    });
  }

  function boaRefresh(rebind) {
    remountMirrarly(rebind);
    initFindation();
    // Yotpo / Seal only after a similar-product swap — avoid fighting their
    // own first-paint init on every PDP.
    if (!swapped) return;
    boaSyncYotpo(rebind);
    if (rebind) {
      boaSyncSealSubscriptions();
    }
  }

  function boaFocusCheckedSwatch() {
    const checked = boaRoot().querySelector("input.swatch__input:checked");
    if (checked && typeof checked.focus === "function") {
      checked.focus({ preventScroll: true });
    }
  }

  function boaSwatchProductHandle(swatch) {
    const group = swatch.closest("[data-variant-group-handle]");
    if (group && group.dataset.variantGroupHandle) {
      return group.dataset.variantGroupHandle;
    }
    const onScreen = boaProduct();
    return (onScreen && onScreen.handle) || "";
  }

  async function handleColorPick(e) {
    const swatch = e.target.closest(".swatch__label");
    if (
      !swatch ||
      swatch.hasAttribute("data-similar-swatch") ||
      swatch.closest("[data-similar-group]")
    ) {
      return;
    }
    if (!window.theme) return;

    // Mobile: gallery Liquid only renders the active variant's media, so a
    // full section swap is required (same path as similar-product swaps).
    if (window.innerWidth < theme.sizes.small) {
      if (replacing) return;
      const handle = boaSwatchProductHandle(swatch);
      const variantId = String(swatch.dataset.variantId || "").split(",")[0];
      if (!handle || !variantId) return;
      boaHoldGallerySlide();
      swapProductSection(handle, variantId);
      return;
    }

    boaHoldGallerySlide();
    const { sectionId } = swatch.dataset;
    const input =
      (swatch.htmlFor && document.getElementById(swatch.htmlFor)) ||
      swatch.previousElementSibling;
    if (input && input.matches && input.matches("input.swatch__input")) {
      input.checked = true;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
    const idInput = document.querySelector('[name="id"][data-product-select]');
    const variantId =
      (idInput && idInput.value) ||
      String(swatch.dataset.variantId || "").split(",")[0];
    if (!sectionId || !variantId) {
      boaReleaseGallerySlide();
      return;
    }

    const token = ++colorPickSeq;
    try {
      const handle = boaSwatchProductHandle(swatch);
      const url = buildProductUrl(handle, variantId, { sectionId });
      const response = await fetch(url);
      const variantElement = await response.text();
      if (token !== colorPickSeq) {
        boaReleaseGallerySlide();
        return;
      }
      const productElement = new DOMParser().parseFromString(
        variantElement,
        "text/html"
      );
      const newGalleryElement = productElement.querySelector(GALLERY_SELECTOR);
      const newShadeElement = productElement.querySelector(".radio__legend");
      const swatches = document.querySelector(".selector-wrapper--swatches");
      if (!swatches) {
        boaReleaseGallerySlide();
        return;
      }
      swatches.removeEventListener("click", handleColorPick, true);
      const currentGalleryElement = document.querySelector(GALLERY_SELECTOR);
      const currentShadeElement = document.querySelector(".radio__legend");
      if (!newGalleryElement || !currentGalleryElement || !currentShadeElement) {
        boaReleaseGallerySlide();
        swatches.addEventListener("click", handleColorPick, true);
        return;
      }
      currentShadeElement.replaceWith(newShadeElement);
      boaCrossfadeGallery(
        currentGalleryElement,
        newGalleryElement,
        (_gallery, startFade) => {
          try {
            boaReloadProductSections(document.querySelector(SECTION_SELECTOR));
          } finally {
            startFade();
          }
        }
      );
      // Theme updateHistoryState (from the change event above) owns ?variant=.
      swatches.addEventListener("click", handleColorPick, true);
    } catch (e) {
      boaReleaseGallerySlide();
    }
  }

  function bindSwatchGallery() {
    const swatches = document.querySelector(".selector-wrapper--swatches");
    if (!swatches) return;
    swatches.removeEventListener("click", handleColorPick, true);
    swatches.addEventListener("click", handleColorPick, true);
  }

  function onReady(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  onReady(function () {
    const navEntry = performance.getEntriesByType("navigation")[0];
    if (navEntry && navEntry.type === "navigate") {
      resetPageSimilarState();
    }
    // Inline PVC already ran during HTML parse for the landing product.
    const landing = boaProduct();
    if (landing && landing.id) {
      boaPvcCountedProductId = String(landing.id);
    }
    bindVariantSections();
    // First load: Findation + move Mirrarly into the quiz. Third-party resync
    // and the Try-It-On click hijack only run after a similar-product swap.
    initFindation();
    bindSwatchGallery();

    if (!boaMoveMirrarlyToQuiz()) {
      let tries = 0;
      const iv = setInterval(function () {
        if (boaMoveMirrarlyToQuiz() || ++tries > 40) clearInterval(iv);
      }, 250);

      const mo = new MutationObserver(boaMoveMirrarlyToQuiz);
      mo.observe(document.documentElement, { childList: true, subtree: true });
      document.addEventListener("shopify:section:load", boaMoveMirrarlyToQuiz);
      document.addEventListener("shopify:block:select", boaMoveMirrarlyToQuiz);
    }
  });

  ["boa:product:section:replaced", "shopify:section:load"].forEach((name) => {
    document.addEventListener(name, () => {
      requestAnimationFrame(() => {
        bindVariantSections();
        boaRefresh(true);
        bindSwatchGallery();
        if (swapped && name === "boa:product:section:replaced") {
          boaSyncPvcVisitors();
          boaFocusCheckedSwatch();
        }
      });
    });
  });
})();
